import React, { FC, PropsWithChildren, useMemo } from 'react';
import { Paragraph as Text } from './styles';
import { Theme } from 'static/theme';
import { Colors } from 'static/theme/colors';
import { useTheme } from '@emotion/react';

export interface ParagraphProps {
    variant?: keyof Colors;
    grey?: number;
    lines?: number;
    center?: boolean;
    className?: string;
    noMargin?: boolean;
}

const Paragraph: FC<PropsWithChildren<ParagraphProps>> = ({ children, variant, grey, center, className, noMargin, lines }) => {
    const theme = useTheme() as Theme;
    const color = useMemo(() => (variant ? theme.colors[variant] : grey ? theme.greys[grey] : theme.colors.dark), [variant, grey]);

    return (
        <Text color={color} center={center} className={className} noMargin={noMargin} lines={lines}>
            {children}
        </Text>
    );
};

export default Paragraph;

